import React from 'react'
import "./SidebarRow.css"

function SidebarRow({page, Icon, title, name, baseDir}) {

    return (
        <a href={baseDir+"/"+name.toLowerCase()}>
          <div className={`sidebarRow ${name===page && 'selected'}`}>
            <Icon className="sidebarRow__icon"/>
            <h2 className="sidebarRow__title">{title}</h2>
        </div>
        </a>
    )
}

export default SidebarRow
